import { buildRows } from "./buildRows";
import { tableTemplate } from "./tableTemplate";
export function initUI(songHistory, songs) {
    document.querySelector("#search-known").removeAttribute("disabled");
    const songContainer = document.querySelector(".song-container");
    let html = "";
    console.log(songHistory);
    songs.sort((a, b) => Number(a.id) - Number(b.id));
    if (songs.length) {
        html += `
			<section class="known-or-not">
				<!-- <h3>Hymns we know (${songs.length})</h3> -->
				<p class="songs-meta summary">We know ${songHistory.know.length} songs out of ${songHistory.songs.length}. ${songHistory.dontknow.length - songHistory.forgot.length} of those we have never sung before, and ${songHistory.forgot.length} of those have expired. We recently added ${songHistory.recent.length} new songs, and ${songHistory.expires.length} will expire soon.</p>
				<p class="songs-meta">Viewing ${songs.length} of ${songHistory.songs.length} songs</p>
				${tableTemplate(buildRows(songs))}
                <p style="font-size: 12px; opacity: .5;">Last refreshed: ${new Date(songHistory.lastUpdated).toString()}</p>
			</section>`;
    }
    else {
        html += `<p class="no-results">
		    <i class="fas fa-times"></i>
		    We don’t know that one yet.
		</p>`;
    }
    songContainer.innerHTML = html;
}
